import store from '../store/index';
import UtilService from './util';

class FilterService {
  queryFilters(applications, paymentPage) {
    const filter = store.state.application_filter.filter;
    const filterOptions = store.state.application_filter.filterOptions;

    function filterteamLeaderOnly(application) {
      return filter.teamLeaderOnly
        ? UtilService.mappedUsers().some(
            (e) =>
              e.id === application.moderatorId &&
              (filter.teamLeaderOnly === 'teamLeader'
                ? e.isTeamLeader
                : !e.isTeamLeader)
          )
        : true;
    }

    function filterUniversity(application) {
      return filter.university && filter.university.length
        ? filter.university.some((docFilter) =>
            application.university.title
              .toLowerCase()
              .includes(docFilter.title.toLowerCase())
          )
        : true;
    }

    function filterAddress(application) {
      return filter.address && filter.address.length
        ? filter.address.some((docFilter) =>
            application.university.address
              .toLowerCase()
              .includes(docFilter.address.toLowerCase())
          )
        : true;
    }

    function filterAdmins(application) {
      return filter.admins && filter.admins.length
        ? filter.admins.some((docFilter) => {
            const managerUniId = filterOptions.adminsWithUni.find(
              (admin) => admin.username === docFilter.value
            ).uniIds;
            return managerUniId.includes(application.university.id);
          })
        : true;
    }

    function filterDate(application) {
      return filter.time
        ? UtilService.dateCheck(
            new Date(
              new Date().setDate(new Date(Date.now()).getDate() - filter.time)
            ),
            new Date(),
            new Date(application.date)
          )
        : true;
    }

    function filterModerator(application) {
      return filter.moderator && filter.moderator.length
        ? filter.moderator.some(
            (docFilter) => docFilter.value === application.moderator
          )
        : true;
    }

    function filterCourse(application) {
      return filter.course && filter.course.length
        ? filter.course.some(
            (docFilter) => docFilter.value === application.courseTitle
          )
        : true;
    }

    function filterStudent(application) {
      return filter.student && filter.student.length
        ? filter.student.some((docFilter) =>
            application.studentData.personalInformation.student_name
              .toLowerCase()
              .includes(docFilter.value.toLowerCase())
          )
        : true;
    }

    function filterStatus(application) {
      return filter.status && filter.status.length
        ? filter.status.some((docFilter) => {
            return docFilter.value === 'All'
              ? true
              : docFilter.value === 'None'
              ? application.status === ''
              : application.status === docFilter.value;
          })
        : true;
    }

    function filterFinancialStatus(application) {
      return filter &&
        filter.studentFormStatus &&
        filter.studentFormStatus.length
        ? filter.studentFormStatus.some((docFilter) => {
            return docFilter.value === 'All'
              ? true
              : docFilter.value === 'None'
              ? !application.studentForm ||
                application.studentForm.studentFormStatus === ''
              : application.studentForm &&
                application.studentForm.studentFormStatus === docFilter.value;
          })
        : true;
    }

    function filterUpfrontStatus(application) {
      return filter && filter.upfrontStatus && filter.upfrontStatus.length
        ? filter.upfrontStatus.some((docFilter) => {
            return docFilter.value === 'Needs review'
              ? application.studentForm &&
                  !application.studentForm.upfrontFormStatus &&
                  application.studentForm.upfrontForm
              : docFilter.value === 'All'
              ? true
              : docFilter.value === 'None'
              ? !application.studentForm ||
                application.studentForm.upfrontFormStatus === '' ||
                application.studentForm.upfrontFormStatus === null
              : application.studentForm &&
                application.studentForm.upfrontFormStatus === docFilter.value;
          })
        : true;
    }

    function filterScreenshotApproval(application) {
      return filter.needsScreenShootApproval
        ? application.studentForm &&
            application.studentForm.printscreenUrl &&
            !application.studentForm.printscreenApproved
        : true;
    }

    function filterFinalStatus(application) {
      return filter && filter.finalSatus && filter.finalSatus.length
        ? filter.finalSatus.some((docFilter) => {
            return docFilter.value === 'Needs review'
              ? application.studentForm &&
                  !application.studentForm.finalFormStatus &&
                  application.studentForm.finalForm
              : docFilter.value === 'All'
              ? true
              : docFilter.value === 'None'
              ? !application.studentForm ||
                application.studentForm.finalFormStatus === '' ||
                application.studentForm.finalFormStatus === null
              : application.studentForm &&
                application.studentForm.finalFormStatus === docFilter.value;
          })
        : true;
    }

    function filterEnglish(application) {
      return filter.english_test && filter.english_test.length
        ? filter.english_test.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            const filterTime = {
              Today: -1,
              Tomorrow: -2,
              'This week': -7,
            };
            const parsedDate = new Date(
              application.studentData.generalInfo.english_test
            );
            return ['Today', 'Tomorrow', 'This week'].includes(filterValue) &&
              UtilService.isValidDate(parsedDate)
              ? UtilService.dateCheck(
                  new Date(
                    new Date().setDate(new Date(Date.now()).getDate() - 1)
                  ),
                  new Date(
                    new Date().setDate(
                      new Date(Date.now()).getDate() - filterTime[filterValue]
                    )
                  ),
                  new Date(parsedDate)
                )
              : filterValue.includes('Custom')
              ? UtilService.dateCheck(
                  new Date(filterValue.split('-')[1]),
                  new Date(filterValue.split('-')[2]),
                  new Date(parsedDate)
                )
              : filterValue ===
                application.studentData.generalInfo.english_test;
          })
        : true;
    }

    function filterInterview(application) {
      return filter.interview && filter.interview.length
        ? filter.interview.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            const filterTime = {
              Today: -1,
              Tomorrow: -2,
              'This week': -7,
            };
            const parsedDate = new Date(
              application.studentData.generalInfo.interview
            );
            return ['Today', 'Tomorrow', 'This week'].includes(filterValue) &&
              UtilService.isValidDate(parsedDate)
              ? UtilService.dateCheck(
                  new Date(
                    new Date().setDate(new Date(Date.now()).getDate() - 1)
                  ),
                  new Date(
                    new Date().setDate(
                      new Date(Date.now()).getDate() - filterTime[filterValue]
                    )
                  ),
                  new Date(parsedDate)
                )
              : filterValue.includes('Custom')
              ? UtilService.dateCheck(
                  new Date(filterValue.split('-')[1]),
                  new Date(filterValue.split('-')[2]),
                  new Date(parsedDate)
                )
              : filterValue === application.studentData.generalInfo.interview;
          })
        : true;
    }

    function filterBooking(application) {
      return filter.booking && filter.booking.length
        ? filter.booking.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            return filterValue === application.studentData.generalInfo.booking;
          })
        : true;
    }

    function filterSfe(application) {
      return filter.sfe && filter.sfe.length
        ? filter.sfe.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            return (
              filterValue ===
              application.studentData.generalInfo.student_finance
            );
          })
        : true;
    }

    function filterReferal(application) {
      return filter.student_referal && filter.student_referal.length
        ? filter.student_referal.some((docFilter) => {
            return (
              docFilter.value ===
              application.studentData.personalInformation.student_referal
            );
          })
        : true;
    }

    function filterStudentId(application) {
      return filter.studentId && filter.studentId.length
        ? filter.studentId.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            return (
              filterValue === application.studentData.generalInfo.studentId
            );
          })
        : true;
    }

    function filterIntake(application) {
      return filter.intake && filter.intake.length
        ? filter.intake.some((docFilter) => {
            const filterValue =
              docFilter.value === 'None' ? '' : docFilter.value;
            return (
              application.studentData.personalInformation.intake === filterValue
            );
          })
        : true;
    }

    function filterTimetable(application) {
      return filter.timetable.length
        ? filter.timetable.every((docFilter) =>
            application.courseData.timetable_options.includes(docFilter)
          )
        : true;
    }

    function filterTeams(application) {
      return filter.teams && filter.teams.length
        ? filter.teams.some(
            (docFilter) => docFilter.teamId === application.team.teamId
          )
        : true;
    }

    function filterNeedsApproval(application) {
      return filter.needsApproval ? !application.isApproved : true;
    }

    function filterDeletedAgents(application) {
      return filter.deletedAgents ? application.moderatorDeleted : true;
    }

    const query = applications
      .filter(filterDate)
      .filter(filterUniversity)
      .filter(filterModerator)
      .filter(filterCourse)
      .filter(filterStudent)
      .filter(filterStatus)
      .filter(filterIntake)
      .filter(filterTimetable)
      .filter(filterAddress)
      .filter(filterBooking)
      .filter(filterEnglish)
      .filter(filterInterview)
      .filter(filterStudentId)
      .filter(filterTeams)
      .filter(filterSfe)
      .filter(filterReferal)
      .filter(filterNeedsApproval)
      .filter(filterAdmins)
      .filter(filterteamLeaderOnly)
      .filter(filterDeletedAgents)
      .sort((a, b) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });

    return paymentPage
      ? query
          .filter(filterFinancialStatus)
          .filter(filterUpfrontStatus)
          .filter(filterFinalStatus)
          .filter(filterScreenshotApproval)
      : query;
  }
}

export default new FilterService();
